import f from "../../../funcs";
import Events from "../../Events";
import RowsStorage from "../RowsStorage";


// TODO: удалить этот плагин, когда появится нормальный кэш
// обновляем поле linked_companies

// TODO: default load company linked_companies if not exists in cache (in fixCreate/fixRemove)

let LIST_COMPANY = RowsStorage.get("LIST_COMPANY");
let ORDER = RowsStorage.get("ORDER");
let OPERATION = RowsStorage.get("OPERATION");

let StupidFixLinkedCompany = Events.extend("StupidFixLinkedCompany", {
    init(COMPANY_COMPANY_LINK) {
        let that = this;

        // CREATE
        let create = COMPANY_COMPANY_LINK.create_with();

        COMPANY_COMPANY_LINK.create = function(data, callback) {
            if ( f.isFunction(data) ) {
                callback = data;
                data = {};
            }
            if ( !f.isFunction(callback) ) {
                callback = function() {};
            }

            create(data, function(err, model) {
                if ( !err ) {
                    that.fixCreate(data.ID_LIST_COMPANY_A, data.ID_LIST_COMPANY_B);
                }

                callback(err, model);
            });
        };

        COMPANY_COMPANY_LINK.create_with = function() {
            let args = [].slice.call(arguments);
            return function() {
                let args2 = [].slice.call(arguments);
                return COMPANY_COMPANY_LINK.create.apply(COMPANY_COMPANY_LINK, args.concat(args2));
            };
        };

        // UPDATE
        let update = COMPANY_COMPANY_LINK.update_with();

        COMPANY_COMPANY_LINK.update = function(id, changes, callback) {
            if ( !f.isFunction(callback) ) {
                callback = function() {};
            }

            let linkModel = COMPANY_COMPANY_LINK.collection.get(id);
            if ( linkModel ) {
                that.fixRemove(linkModel.get("ID_LIST_COMPANY_A"), linkModel.get("ID_LIST_COMPANY_B"));
            }

            update(id, changes, function(err, linkModel) {
                if ( !err ) {
                    that.fixCreate(linkModel.get("ID_LIST_COMPANY_A"), linkModel.get("ID_LIST_COMPANY_B"));
                }

                callback(err, linkModel);
            });
        };

        COMPANY_COMPANY_LINK.update_with = function() {
            let args = [].slice.call(arguments);
            return function() {
                let args2 = [].slice.call(arguments);
                return COMPANY_COMPANY_LINK.update.apply(COMPANY_COMPANY_LINK, args.concat(args2));
            };
        };

        // TRASH
        let trash = COMPANY_COMPANY_LINK.trash_with();

        COMPANY_COMPANY_LINK.trash = function(ids, callback) {
            if ( !f.isFunction(callback) ) {
                callback = function() {};
            }

            if ( !f.isArray(ids) ) {
                ids = [ids];
            }

            // TODO: load if not exists in cache
            let linkModels = COMPANY_COMPANY_LINK.collection.getModels(ids || []) || [];

            linkModels.forEach(function(linkModel) {
                that.fixRemove(linkModel.get("ID_LIST_COMPANY_A"), linkModel.get("ID_LIST_COMPANY_B"));
            });

            return trash(ids, callback);
        };

        COMPANY_COMPANY_LINK.trash_with = function() {
            let args = [].slice.call(arguments);
            return function() {
                let args2 = [].slice.call(arguments);
                return COMPANY_COMPANY_LINK.trash.apply(COMPANY_COMPANY_LINK, args.concat(args2));
            };
        };
    },

    fixCreate(companyId1, companyId2) {
        if ( !companyId1 || !companyId2 ) {
            return;
        }

        let companyModel;

        companyModel = LIST_COMPANY.collection.get(companyId1);
        if ( companyModel ) {
            this._fixModelCreate(companyModel, "LINKED_COMPANIES", companyId2);
        }

        companyModel = LIST_COMPANY.collection.get(companyId2);
        if ( companyModel ) {
            this._fixModelCreate(companyModel, "LINKED_COMPANIES", companyId1);
        }

        ORDER.collection.each(function(orderModel) {
            if ( orderModel.get("ID_COMPANY_CLIENT") == companyId1 ) {
                this._fixModelCreate(orderModel, "CLIENT_LINKED_COMPANIES", companyId2);
            }
            if ( orderModel.get("ID_COMPANY_CLIENT") == companyId2 ) {
                this._fixModelCreate(orderModel, "CLIENT_LINKED_COMPANIES", companyId1);
            }

            if ( orderModel.get("ID_COMPANY_PARTNER") == companyId1 ) {
                this._fixModelCreate(orderModel, "PARTNER_LINKED_COMPANIES", companyId2);
            }
            if ( orderModel.get("ID_COMPANY_PARTNER") == companyId2 ) {
                this._fixModelCreate(orderModel, "PARTNER_LINKED_COMPANIES", companyId1);
            }
        }.bind(this));

        OPERATION.collection.each(function(operationModel) {
            if ( operationModel.get("ID_COMPANY_EXECUTOR") == companyId1 ) {
                this._fixModelCreate(operationModel, "COMPANY_EXECUTOR_LINKED_COMPANIES", companyId2);
            }
            if ( operationModel.get("ID_COMPANY_EXECUTOR") == companyId2 ) {
                this._fixModelCreate(operationModel, "COMPANY_EXECUTOR_LINKED_COMPANIES", companyId1);
            }
        }.bind(this));
    },

    _fixModelCreate(model, linkedArrayField, companyId) {
        companyId = companyId + "";

        let linked;

        linked = model.get(linkedArrayField) || [];
        linked = linked.map(function(id) {return id + "";});

        let index = linked.indexOf(companyId);
        if ( index == -1 ) {
            linked.push(companyId);
        }

        if ( !linked || !linked.length ) {
            linked = null;
        }

        let changes = {};
        changes[ linkedArrayField ] = linked;
        model.set(changes, { update: false });
        model.storage.sendEvent("__customRefreshExclude", [model]);
    },

    fixRemove(companyId1, companyId2) {
        if ( !companyId1 || !companyId2 ) {
            return;
        }

        let companyModel;

        companyModel = LIST_COMPANY.collection.get(companyId1);
        if ( companyModel ) {
            this._fixModelRemove(companyModel, "LINKED_COMPANIES", companyId2);
        }

        companyModel = LIST_COMPANY.collection.get(companyId2);
        if ( companyModel ) {
            this._fixModelRemove(companyModel, "LINKED_COMPANIES", companyId1);
        }

        ORDER.collection.each(function(orderModel) {
            if ( orderModel.get("ID_COMPANY_CLIENT") == companyId1 ) {
                this._fixModelRemove(orderModel, "CLIENT_LINKED_COMPANIES", companyId2);
            }
            if ( orderModel.get("ID_COMPANY_CLIENT") == companyId2 ) {
                this._fixModelRemove(orderModel, "CLIENT_LINKED_COMPANIES", companyId1);
            }

            if ( orderModel.get("ID_COMPANY_PARTNER") == companyId1 ) {
                this._fixModelRemove(orderModel, "PARTNER_LINKED_COMPANIES", companyId2);
            }
            if ( orderModel.get("ID_COMPANY_PARTNER") == companyId2 ) {
                this._fixModelRemove(orderModel, "PARTNER_LINKED_COMPANIES", companyId1);
            }
        }.bind(this));

        OPERATION.collection.each(function(operationModel) {
            if ( operationModel.get("ID_COMPANY_EXECUTOR") == companyId1 ) {
                this._fixModelRemove(operationModel, "COMPANY_EXECUTOR_LINKED_COMPANIES", companyId2);
            }
            if ( operationModel.get("ID_COMPANY_EXECUTOR") == companyId2 ) {
                this._fixModelRemove(operationModel, "COMPANY_EXECUTOR_LINKED_COMPANIES", companyId1);
            }
        }.bind(this));
    },

    _fixModelRemove(model, linkedArrayField, companyId) {
        companyId = companyId + "";

        let linked;
        linked = model.get(linkedArrayField) || [];
        linked = linked.map(function(id) {return id + "";});

        let index = linked.indexOf(companyId);
        if ( index != -1 ) {
            linked.splice(index, 1);
        }

        if ( !linked || !linked.length ) {
            linked = null;
        }

        let changes = {};
        changes[ linkedArrayField ] = linked;
        model.set(changes, { update: false });
        model.storage.sendEvent("__customRefreshExclude", [model]);
    }
});

export default StupidFixLinkedCompany;
